module.exports = __webpack_public_path__ + "assets/img/06.8f57977a.png";